// app/javascript/controllers/accordion_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'icon', 'header'];

  connect() {
    this.isExpanded = false;
    this.updateHeight();
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.updateHeight();
  }

  updateHeight() {
    if (this.isExpanded) {
      this.contentTarget.style.height = 'auto';
      this.contentTarget.style.paddingTop = '32px';
      this.iconTarget.style.transform = 'rotate(180deg)';

      // Adiciona a classe de borda quando aberto (se tiver o target header)
      if (this.hasHeaderTarget && this.element.dataset.showBorder === 'true') {
        this.headerTarget.classList.add(
          'tw-border-b',
          'tw-border-solid',
          'tw-border-coolGray-200',
          'tw-border-t-0',
          'tw-border-l-0',
          'tw-border-r-0',
        );
      }
    } else {
      this.contentTarget.style.height = '0px';
      this.contentTarget.style.paddingTop = '0px';
      this.iconTarget.style.transform = 'rotate(0deg)';

      // Remove a classe de borda quando fechado
      if (this.hasHeaderTarget) {
        this.headerTarget.classList.remove(
          'tw-border-b',
          'tw-border-solid',
          'tw-border-coolGray-200',
          'tw-border-t-0',
          'tw-border-l-0',
          'tw-border-r-0',
        );
      }
    }
  }
}
